import TableHeader from '../../../../../models/TableHeader';

class TableFichaClienteFactory {
  makeCabecalhoTable() {
    return [
      new TableHeader({
        id: 'data',
        label: 'Data',
        alignCell: 'center',
        maxWidth: 90,
      }),
      new TableHeader({
        id: 'processo',
        label: 'Processo',
        alignCell: 'center',
        maxWidth: 100,
      }),
      new TableHeader({
        id: 'nomeDoDevedor',
        label: 'Nome do Devedor',
        alignCell: 'left',
        maxWidth: 300,
      }),
      new TableHeader({
        id: 'valorPrincipal',
        label: 'Valor Principal',
        alignCell: 'right',
        maxWidth: 120,
      }),
      new TableHeader({
        id: 'fase',
        label: 'Fase',
        alignCell: 'center',
        maxWidth: 120,
      }),
      new TableHeader({
        id: 'motivoBaixa',
        label: 'Motivo de Baixa',
        alignCell: 'center',
        maxWidth: 200,
      }),
    ];
  }
}


export const tableFichaClienteFactory = new TableFichaClienteFactory();
